import { SPFieldType } from 'consts';
import {
	useSSOConfigCurrentFieldsInitialized,
	useSSOConfigFields
} from 'contexts/SSOConfigFieldsContext';
import React from 'react';
import MDCopyField from './MDCopyField';

interface ISPDataFieldProps {
	fieldName: string;
	displayName: string;
}

const SPDataField: React.FC<ISPDataFieldProps> = ({
	fieldName,
	displayName
}) => {
	const { getFieldValue, isSubTenant } = useSSOConfigFields();
	const fieldsReady = useSSOConfigCurrentFieldsInitialized();
	const value = getFieldValue(fieldName as SPFieldType);

	return (
		<MDCopyField
			displayName={displayName}
			fieldName={fieldName}
			disabled={!fieldsReady || isSubTenant}
			value={value}
		/>
	);
};

export default SPDataField;
